import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-birthday-card',
  templateUrl: './birthday-card.component.html',
  styleUrls: ['./birthday-card.component.scss']
})
export class BirthdayCardComponent implements OnInit {

  @Input() birthday: any;
  @Output() openEditForm = new EventEmitter<any>();
  
  onEditGiftCard() {
    this.openEditForm.emit(this.birthday);
  }

  isMaleService(): boolean {
    return this.birthday?.services?.[0] === environment.serviceIds.MALE_ID;
  }
  
  constructor() { }

  ngOnInit(): void {

  }

}
